<div class="card" id="performance">
  <div class="card-header">
    <div class="row align-items-center">
      <div class="col-12 col-md-3">
        <h3>
          {{"GENERICS.APP_TITLE" | translate}}
          <span class="text-light">{{"DASHBOARD.PERFORMANCE" | translate}}</span>
        </h3>
      </div>
      <div class="col-12 col-md-9 text-md-right">
        <div class="row justify-content-end filters-container">
          <div class="col-12 col-md-auto pt-1">
            <button class="btn btn-outline-teal toggle-index" (click)="toggleIbbXbi()" [ngClass]="{'active': getIbbXbiCurrentState()}">IBB/XBI</button>
            <button class="btn btn-outline-teal toggle-index" (click)="toggleMood()" [ngClass]="{'active': getMoodCurrentState()}">Mood</button>
          </div>
          <span class="divider"></span>
          <div class="col-12 col-md-auto d-flex">
            <fieldset class="fieldset-dropdowns">
              <!-- Hidden visually on phones, but kept: it is the field's only accessible name. -->
              <span class="fake-label me-2 mb-0">{{"GENERICS.DATE" | translate}}:</span>
              <!-- Positioning host for the placeholder overlay, as on Headlines. -->
              <div class="pf-date-control" [class.pf-date-control--empty]="showDatePlaceholder">
                <rms-date-picker id="dateRange"
                                 name="dateRange"
                                 #dateRangeRef="ngModel"
                                 [(ngModel)]="chartDateRange"
                                 (ngModelChange)="onDateRangeChanged($event)"
                                 [isRange]="true">
                </rms-date-picker>
                <!-- Inert to the pointer, so the click still reaches the input underneath. -->
                <div class="pf-date-placeholder-overlay" *ngIf="showDatePlaceholder" aria-hidden="true">{{datePlaceholder}}</div>
              </div>
            </fieldset>
          </div>
          <span class="divider"></span>
          <div class="col-12 col-md-auto">
            <div class="btn-group btn-group-toggle">
              <label class="cursor-pointer" [ngClass]="{ 'active': chartDatePortion === '10 D' }">
                <input type="radio" id="10D" name="10D" [value]="'10 D'" [(ngModel)]="chartDatePortion" (ngModelChange)="filterChart($event)"> 10D
              </label>
              <span class="divider"></span>
              <label class="cursor-pointer" [ngClass]="{ 'active': chartDatePortion === '1M' }">
                <input type="radio" id="1M" name="1M" [value]="'1M'" [(ngModel)]="chartDatePortion" (ngModelChange)="filterChart($event)"> 1M
              </label>
              <span class="divider"></span>
              <label class="cursor-pointer" [ngClass]="{ 'active': chartDatePortion === 'YTD' }">
                <input type="radio" id="YTD" name="YTD" [value]="'YTD'" [(ngModel)]="chartDatePortion" (ngModelChange)="filterChart($event)"> YTD
              </label>
              <span class="divider"></span>
              <label class="cursor-pointer" [ngClass]="{ 'active': chartDatePortion === '1Y' }">
                <input type="radio" id="1Y" name="1Y" [value]="'1Y'" [(ngModel)]="chartDatePortion" (ngModelChange)="filterChart($event)"> 1Y
              </label>
              <span class="divider"></span>
              <label class="cursor-pointer" [ngClass]="{ 'active': chartDatePortion === 'MAX' }">
                <input type="radio" id="MAX" name="MAX" [value]="'MAX'" [(ngModel)]="chartDatePortion" (ngModelChange)="filterChart($event)"> MAX
              </label>
              <ng-container *ngFor="let preset of getSortedMoodIndexPresets()">
                <span class="divider"></span>
                <label class="cursor-pointer" [ngClass]="{ 'active': chartDatePortion === preset }">
                  <input type="radio" id="{{preset}}" name="{{preset}}" [value]="preset" [(ngModel)]="chartDatePortion" (ngModelChange)="filterChart($event)"> {{ preset }}
                </label>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="card-body">
    <div class="chart-container">
      <ng-container *ngIf="loadingChartData">
        <rms-loading-spinner></rms-loading-spinner>
      </ng-container>
      <div #performanceChart class="line-chart"></div>
    </div>
  </div>
</div>
